import React, { useRef } from 'react';
import styled from 'styled-components';
import { CustomTooltip, IconButton } from 'components';
import { Palette } from 'config';
import { useSignal } from '@preact/signals-react';
import { DailyBudgetTooltip } from './DailyBudgetTooltip';
import { Pen } from 'assets/icons';

export const DailyBudget = (props) => {
  const { daily_Cost, budget, campaignStatus, budgetPercentage } = props.data;

  const isOpenTooltip$ = useSignal(false);
  const btnRef = useRef(null);

  const budgetLeft = (budget - daily_Cost).toFixed(2);
  const isDeletedCampaign = campaignStatus === 9;

  const handleClickOutside = (event) => {
    if (btnRef.current && btnRef.current.contains(event.target)) return;
    if (isOpenTooltip$.value && btnRef.current && !btnRef.current.contains(event.target)) {
      isOpenTooltip$.value = false;
    }
  };

  const toggleTooltip = () => {
    isOpenTooltip$.value = true;
    window.addEventListener('wheel', () => (isOpenTooltip$.value = false), {
      capture: true,
      once: true,
    });
    document.addEventListener('click', handleClickOutside, { capture: true, once: true });
  };

  return (
    <Container>
      <MyProgressBar
        max={budget}
        value={budget - budgetLeft}
        percentage={100 - Math.round(budgetPercentage)}
      />
      <div
        style={{
          display: 'flex',
          gap: '2px',
          width: '100%',
          justifyContent: 'center',
        }}
      >
        <TextWrap>
          <span style={{ fontWeight: '500' }}>${(budget - budgetLeft)?.toFixed(2) || 0}</span>
          <span style={{ color: '#94A3B8' }}>/</span>
          <span>${budget.toFixed(2)}</span>
        </TextWrap>
        {!isDeletedCampaign && (
          <PenWrap>
            <CustomTooltip
              text={
                <DailyBudgetTooltip
                  ref={btnRef}
                  budgetValue={budget}
                  data={props.data}
                  isOpen$={isOpenTooltip$}
                />
              }
              content={
                <IconButton.Micro
                  icon={Pen}
                  type={IconButton.btnTypes.tertiary}
                  style={{ alignSelf: 'start', marginTop: '-3px' }}
                  isPressed={isOpenTooltip$.value}
                  onClick={toggleTooltip}
                />
              }
              isOpen={isOpenTooltip$.value}
            />
          </PenWrap>
        )}
      </div>
    </Container>
  );
};

const TextWrap = styled.div`
  display: flex;
  column-gap: 4px;
  justify-content: center;
  flex-wrap: wrap;
  max-width: calc(100% - 34px);
  color: ${Palette.PrimaryGray._700};
  font-size: 14px;
  line-height: 1.35;
`;

const PenWrap = styled.div`
  width: 2px;
  overflow: visible;

  & > * {
    min-width: 18px;
  }
`;

const Container = styled.div`
  border-right: 1px solid ${Palette.PrimaryGray._200};
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 4px;
  padding: 0 4px;

  button {
    visibility: hidden;
  }
`;

const MyProgressBar = styled.progress`
  margin: 16px auto 2px auto;

  width: 94px;
  height: 4px;
  -webkit-appearance: none;
  appearance: none;
  opacity: 0.5;

  ::-webkit-progress-bar {
    background-color: ${Palette.PrimaryGray._300};
  }

  ::-webkit-progress-value {
    background-color: ${({ percentage }) => {
      if (percentage <= 20) return Palette.Teal._500;
      if (percentage > 20 && percentage <= 70) return Palette.Amber._500;
      if (percentage > 70) return Palette.Red._500;
    }};
  }
`;
